import { CheckCircle2, School, Sparkles, ArrowRight } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const methodPoints = [
  "Clases dinámicas y participativas",
  "Desarrollo de las 4 habilidades: escucha, lectura, escritura y conversación",
  "Acompañamiento docente",
  "Recursos digitales y material de apoyo",
  "Evaluación continua de tu progreso",
];

const modalities = [
  {
    icon: School,
    name: "Presencial",
    text: "Aprende en nuestras sedes con clases presenciales, práctica en grupo y acompañamiento directo de los docentes. Nuestro programa se imparte únicamente de forma presencial.",
  },
];

const scheduleNotes = ["Horarios entre semana", "Horarios de fin de semana", "Fechas de inicio de nuevos grupos"];

export default function Methodology() {
  return (
    <>
      <section id="metodologia" className="py-20 lg:py-32 bg-slate-50" data-testid="methodology-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">Nuestra metodología</span>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Aprende de forma dinámica y práctica
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Un enfoque en la comunicación real para que hables inglés desde la primera clase.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <ul className="space-y-4" data-testid="methodology-list">
              {methodPoints.map((p) => (
                <li key={p} className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4">
                  <CheckCircle2 className="w-5 h-5 text-blue-600 mt-0.5 shrink-0" />
                  <span className="text-slate-700 text-sm sm:text-base">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section id="modalidades" className="py-20 lg:py-32 bg-white" data-testid="modalities-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <span className="text-sm font-semibold uppercase tracking-wider text-blue-600">Modalidad y horarios</span>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Clases presenciales que se adaptan a tu estilo de vida
            </h2>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 max-w-2xl gap-6" data-testid="modalities-grid">
            {modalities.map((m, i) => (
              <Reveal key={m.name} delay={i * 0.08}>
                <div
                  data-testid={`modality-card-${m.name.toLowerCase()}`}
                  className="h-full rounded-2xl border border-slate-200 bg-slate-50 p-8 transition-transform hover:-translate-y-1 hover:shadow-lg hover:shadow-blue-900/5"
                >
                  <span className="w-12 h-12 rounded-xl bg-blue-600/10 text-blue-600 flex items-center justify-center">
                    <m.icon className="w-6 h-6" />
                  </span>
                  <h3 className="mt-5 font-heading text-2xl font-semibold text-slate-900">{m.name}</h3>
                  <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{m.text}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-3" data-testid="schedule-notes">
              {scheduleNotes.map((n) => (
                <span
                  key={n}
                  className="inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600"
                >
                  {n}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div
              className="mt-12 rounded-2xl bg-slate-900 p-8 lg:p-12 flex flex-col lg:flex-row lg:items-center gap-6 justify-between"
              data-testid="promo-banner"
            >
              <div className="flex items-start gap-4">
                <span className="w-11 h-11 rounded-xl bg-blue-600 text-white flex items-center justify-center shrink-0">
                  <Sparkles className="w-5 h-5" />
                </span>
                <div>
                  <h3 className="font-heading text-xl sm:text-2xl font-semibold text-white">Promociones y beneficios</h3>
                  <p className="mt-2 text-sm sm:text-base text-slate-300 max-w-xl">
                    Pregunta por nuestras promociones, becas y descuentos especiales. ¡Tu momento es ahora!
                  </p>
                </div>
              </div>
              <a
                href="#contacto"
                data-testid="promo-cta-button"
                className="inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-semibold text-white hover:bg-blue-700 transition-colors shrink-0"
              >
                Más información
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
